import $ from "jquery";

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      $(".download-box-item .open-popup").on("click", (e) => {
        let target = $(e.target);
        let boxItem = target.closest(".download-box-item");
        $(".download-box-item").removeClass("popup-opened");
        boxItem.addClass("popup-opened");
      });

      $(".download-box-item .popup-container .close").on("click", (e) => {
        let target = $(e.target);
        let boxItem = target.closest(".download-box-item");
        boxItem.removeClass("popup-opened");
      });

      // On click outside of popup
      $(document).on("click", (e) => {
        if (!$(e.target).closest(".download-box-item.popup-opened").length) {
          $(".download-box-item").removeClass("popup-opened");
        }
      });

      // press escape to close popup
      $(document).on("keyup", (e) => {
        if (e.key === "Escape") {
          $(".download-box-item").removeClass("popup-opened");
        }
      });

      // collapsible toggle
      $(".download-material.is-accordeon .collapsible-header").on("click", (e) => {

        let parent = $(e.target).closest(".download-material");
        if(parent.hasClass("expanded")){
          parent.removeClass("expanded");
        }else{
          parent.addClass("expanded");
        }

      });

    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
